import { IBackendFullFlow } from 'common/flow/flowBackendInterfaces'
import { LightFlow } from 'shared/api/common/schemas/lightFlow'

export const isBackendFullFlow = (flow: IBackendFullFlow | LightFlow): flow is IBackendFullFlow => {
  return 'draft_batch' in flow && 'triggers' in flow
}
